<template>
  <el-cascader v-bind="$attrs" v-on="$listeners" :props="config" clearable
               :key="key"
               style="width: 100%"></el-cascader>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  extends: BaseVue,
  props: {
    //层级：1-省级，2-市级，3-区县级
    level: {
      require: false,
      type: String,
      default: "3"
    },
    parentCode: {
      require: false,
      type: String,
      default: null
    },
    props: {
      require: false,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      key: 1,
      config: Object.assign({
        lazy: true,
        value: 'areaCode',
        label: 'areaName',
        lazyLoad:  this.loadData
      }, this.props || {})
    }
  },
  created() {
    // this.getCodes(this.codeType, this.parentCode).then((dr) => {
    //   this.items = dr.rows || []
    // });
  },
  methods: {
    loadData(node, resolve) {
      this.postForm("/area/v2/list",{
        parentCode: node.root ? this.parentCode : node.data.areaCode
      }).then(dr=>{
        let items = dr.rows;
        items.forEach(item => {
          //区县是3级
          item.leaf = item.areaLevel == this.level;
        });
        resolve(items);
      })
    }
  },
  watch: {
    level(val) {
      this.key++;
    }
  }
}
</script>
